import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton } from "@mui/material";

import { useEffect, useState } from "react";
import MyTable from "../../../components/MyTable";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import CloseIcon from '@mui/icons-material/Close';
import { DocumentsComponent } from "../../../components/DocumentsComponent";
import AttachFileIcon from '@mui/icons-material/AttachFile';

import "./index.css";
import { S10CouponsToMyChargeHistoryPartial } from "../../../interfaces/s10Employees.interface";
import { CompanyEmployees } from "../../../interfaces/auth.interface";
import { COUPONS_TO_MY_CHARGE_HISTORY_ONE, COUPONS_TO_MY_CHARGE_HISTORY_THREE, COUPONS_TO_MY_CHARGE_HISTORY_TWO } from "../../../constants/signalRequestConsts";
import { CouponStatus } from "../../../enumns/Coupons";

type Employee = (S10CouponsToMyChargeHistoryPartial & CompanyEmployees);

interface TableAbsencesProps {
    rucEmpresa: string;
    requestId: (typeof COUPONS_TO_MY_CHARGE_HISTORY_ONE | typeof COUPONS_TO_MY_CHARGE_HISTORY_TWO |  typeof COUPONS_TO_MY_CHARGE_HISTORY_THREE)

    hiddenFilterOptions?: boolean;
    allowApproveOptions?: boolean;
    setStatusValue: (val: string) => void;
    statusValue: string;
}

const TableAbsences = ({rucEmpresa, hiddenFilterOptions, requestId, allowApproveOptions, setStatusValue, statusValue}: TableAbsencesProps) => {

    const {employeesHistory, employeesLoading} = useSelector((state: RootState) => state.userRequests)[requestId];
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [groupId, setGroupId] = useState<string | null>(null);
    const [searchInputstring, setSearchInputstring] = useState<string>("")
    const [orderedEmployees, setOrderedEmployees] = useState<Employee[]>([])

    useEffect(() => {
        // if (!employeesHistory?.length) return;
        setIsLoading(true)
        setOrderedEmployees([]);
        let employeesByRuc: Employee[] = [];
        for (let i = 0; i < employeesHistory.length; i++) {
            const employee = employeesHistory[i];
            const ruc: string = employee.RUCEmpresa || "sin ruc";
            if (rucEmpresa === "all" || ruc === rucEmpresa) {
                employeesByRuc.push(employee);
            }
        }
        setOrderedEmployees(employeesByRuc);
        setIsLoading(false)
        
    }, [rucEmpresa, statusValue, employeesHistory])

    const tableHeadRows = [
        {
            label: "Colaborador",
            rowKeyName: "Descripcion",
        },{
            label: "Cupón",
            rowKeyName: "CouponName",
        },{
            label: "Fecha Solicitud",
            rowKeyName: "Date",
        },{
            label: "Rango",
            rowKeyName: "RangeDateInfo",
        // },{
        //     label: "Fec. fin",
        //     rowKeyName: "RangeEnd",
        },{
            label: "Estado",
            rowKeyName: "RangeCountString",
            customValue: (headRow: any, row: any) => {
                switch (row.State) {
                    case 1:
                        return <>Aprobado</>
                    case 2:
                        return <>Utilizado</>
                    default:
                        return <>Pendiente</>
                }
            }
        }, {
            label: "",
            rowKeyName: "actions",
            customValue: (headRow: any, row: any) => {
                if (!row.HasAttachment) {
                    return <></>
                }
                return (                                  
                    <Grid
                        container
                        padding={0}
                        spacing={0}
                        // marginTop="1rem"
                        direction="row"
                    >
                        <IconButton
                            aria-label="ver adjuntos"
                            onClick={() =>{
                                setGroupId(row.FilesGroup)
                            }}
                            style={{
                                // minWidth: "2rem",
                                // minHeight: "2rem",
                                padding: "0 !impoertant",

                                lineHeight: "1.25rem", 
                            }}
                        >
                            <AttachFileIcon color="primary" />
                        </IconButton>
                    </Grid>
                )
            },
        },
    ]

    return (
    <Grid item width="100%" marginTop="1.5rem" minHeight="100%">

    <MyTable
            // key="tab-0"
            // hiddenSearchInput={true}
            searchInputString={searchInputstring}
            onChangeSearchInputString={setSearchInputstring}
            
            tableHeadRows={tableHeadRows}
            tableRows={orderedEmployees}
            loading={employeesLoading || isLoading}
            hiddenFilterOptions={hiddenFilterOptions}
            selectControlProps={{
                label: "Estado",
                onChange: async (value: any) => {
                    setStatusValue(value);
                },
                options: [
                    {label: "Todos", value: "-2"},
                    {label: "Pendientes", value: `${CouponStatus.Pendientes}`},
                    {label: "Aprobados", value: `${CouponStatus.Aprobados}`},
                    {label: "Rechazados", value: `${CouponStatus.Rechazados}`},
                    {label: "Utilizados", value: `${CouponStatus.Utilizados}`},
                ],
                value: statusValue,    
            }}
            tableOptionsBar={{
                useDrawer: true,
            }}
        />
        
        {groupId !== null && <Dialog
            key={groupId}
            maxWidth="md"
            
            open={groupId !== null}
            aria-labelledby="responsive-dialog-title"
            style={{width: "100%"}}
            PaperProps={{
                style: {
                width: '80%',
                // maxWidth: '600px',   // Máximo ancho del Dialog
                }
            }}
            fullWidth
        
        >
            <DialogTitle 
                id="responsive-dialog-title" 
                style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                variant="h5"
            >
                Documentos
            </DialogTitle>
            <DialogContent style={{width: "100%", textAlign: "center"}}>
                <DocumentsComponent groupId={groupId} allowToDeleteFiles={false} allowToAddFiles={false} />
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                    <Grid item xs={12} textAlign={"right"}>
                        <Button 
                            variant="outlined" 
                            style={{width: "8rem", margin: ".5rem",}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            onClick={() => setGroupId(null)}
                        >
                            Cerrar
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>}
    </Grid>)
}

export default TableAbsences;